// extracted by mini-css-extract-plugin
module.exports = {"card__content":"style_card__content__2UXR6","grid":"style_grid__jGm0X"};